import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Button extends PureComponent {
  render () {
    let classes = ['Button', 'Button-' + this.props.align]
    if (this.props.classNames !== '') {
      classes.push(this.props.classNames)
    }
    if (this.props.disabled === true) {
      classes.push('Button-Disabled')
    }
    classes.push('Button-' + this.props.variant)
    const style = {
      ...this.props.style,
      '--button-min-width': this.props.minWidth || undefined
    }
    return (
      <button
        type={this.props.type}
        disabled={this.props.disabled}
        style={style}
        className={classes.join(' ')}
        onClick={this.props.onClick}
      >
        {this.props.children}
        <span
          className={`Button-Icon-Container ${this.props.icon ? 'Button-Icon-Container-Visible' : ''}`}
        >
          {this.props.icon}
        </span>
        {
          this.props.notificationBadge !== undefined &&
          <span className="Button-Notification-Badge">{this.props.notificationBadge}</span>
        }
      </button>
    )
  }
}

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: 'button',
  classNames: '',
  align: 'left',
  variant: 'primary',
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  align: PropTypes.string,
  classNames: PropTypes.string,
  style: PropTypes.object,
  notificationBadge: PropTypes.number,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'attention',
    'neutral',
  ]),
  icon: PropTypes.node,
  minWidth: PropTypes.string,
}
export default Button
